import { render, staticRenderFns } from "./VolumeDiscountsTable.vue?vue&type=template&id=04baf7b2"
import script from "./VolumeDiscountsTable.vue?vue&type=script&lang=ts"
export * from "./VolumeDiscountsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports